import { SDLUtil, RequestUtil, StringUtil } from '@/utils';
const setAccountStatusTrendList = ({commit}, data) => {
  commit('SET_ACCOUNT_STATUS_TREND_LIST', data);
};

const setAccountStatusDiffList = ({commit}, data) => {
  commit('SET_ACCOUNT_STATUS_DIFF_LIST', data);
};
const setAccountStatusCspList = ({commit}, data) => {
  commit('SET_ACCOUNT_STATUS_CSP_LIST', data);
};
export default {
  async GET_ACCOUNT_STATUS_TREND_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/status/trend-list?${StringUtil.queryStringfy(params)}`)
    setAccountStatusTrendList(store, data.data);
  },
  async GET_ACCOUNT_STATUS_DIFF_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/status/diff-list?${StringUtil.queryStringfy(params)}`)
    setAccountStatusDiffList(store, data.data);
  },
  async GET_ACCOUNT_STATUS_CSP_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/status/csp-list?${StringUtil.queryStringfy(params)}`)
    setAccountStatusCspList(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/status/accountStatusAction.js